import { ConsultationStatus } from '@enums/consultation-status';
import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { ConsultationTypes } from '@enums/consultation-types';
import { Treatment } from '@enums/treatment';
import { ConsultationRequestAdditionalInfo } from '@models/consultation-request/consultation-request-additional-info';
import { ConsultationRequestHelper } from '@models/consultation-request/consultation-request-helper';
import { Recharge } from '@models/recharge';

import { ConsultationRequestPayment } from './consultation-request-payment';

export class ConsultationRequestRequest {
  public date_of_birth: string;
  public email: string;
  public first_name: string;
  public last_name: string;
  public order_id: string;
  public payment: ConsultationRequestPayment | { paymentType: string };
  public phone: string;
  public sex: string;
  public type: ConsultationTypes;
  public treatment_type: ConsultationTreatmentTypes;
  public treatment_for?: Treatment;
  public consultation_status: ConsultationStatus;
  public pharmacy_id: number;
  public additional_info?: string | ConsultationRequestAdditionalInfo;
  public allergies: string;
  public prescriptions: string;
  public health_info: string;
  public due_date: string;
  public ethnicity?: string;
  public last_menstrual_date: string;
  public positive: string[];
  public race?: string;
  public recharge: Recharge;
  public sex_with: string;
  public terms: boolean;
  public user_id?: number;
  public status: string;

  /**
   * Sets the additional info for the consultation request. If not provided, default additional info may be set based
   * on treatment type.
   *
   * @param {string | ConsultationRequestAdditionalInfo} additionalInfo Optional additional info to set.
   */
  protected setAdditionalInfo(additionalInfo?: string | ConsultationRequestAdditionalInfo): void {
    if (additionalInfo) {
      this.additional_info = additionalInfo;

      return;
    }

    if (
      this.treatment_type === ConsultationTreatmentTypes.FemaleCondom &&
      ConsultationRequestHelper.isPatientUnderMinimumPrescriptionAge(this.date_of_birth)
    ) {
      this.additional_info = ConsultationRequestHelper.getFemaleCondomDefaultAdditionalInfo();

      return;
    }
  }
}
